<template>
  <cardTemplate
    :classCustom="'overall margin-bottom-10'"
    v-if="visibleDashboardItems && visibleDashboardItems.length"
  >
    <template #content>
      <div
        class="header flex-row flex__between padding-bottom-10 has-border__bottom"
      >
        <div class="leftSection">
          <div class="tt theTitle theTitle__lv1"></div>
        </div>
        <div class="rightSection flex-row flex__right">
          <div class="tt theTitle">Văn bản đến</div>
          <div class="tt theTitle">Văn bản dự thảo</div>
          <div class="tt theTitle">Đã phát hành</div>
          <!-- <div class="tt theTitle">Công việc</div> -->
          <!--<div class="tt theTitle">Hành chính</div>-->
        </div>
      </div>
      <div class="body margin-bottom-10">
        <div
          v-for="item in visibleDashboardItems"
          :key="item.id"
          class="item-info flex-row flex__between has-border__bottom"
        >
          <div class="leftSection">
            <div
              :title="buildUserDeptRoleLabel(item.userDeptRole)"
              class="theTitle theTitle__lv1"
            >
              {{ buildUserDeptRoleLabel(item.userDeptRole) }}
            </div>
          </div>
          <div class="rightSection flex-row flex__right">
            <div
              class="theTitle txt-center flex-row flex__center clickable"
              @click="viewListIncomingDocProcessing(item)"
            >
              <span class="number-1 font-size__large font-weight__bold">{{
                item.countOfIncomingDoc || 0
              }}</span
              >&nbsp;
              <span class="number-2"
                >{{ item.countOfUnreadIncomingDoc || 0 }} mới</span
              >
            </div>
            <div
              class="theTitle txt-center flex-row flex__center clickable"
              @click="viewListOutgoingDocProcessing(item)"
            >
              <span class="number-1 font-size__large font-weight__bold">{{
                item.countOfOutGoingDoc || 0
              }}</span
              >&nbsp;
              <span class="number-2"
                >{{ item.countOfUnreadOutGoingDoc || 0 }} mới</span
              >
            </div>
            <div
              class="theTitle txt-center flex-row flex__center clickable"
              @click="viewListBanHanhOutgoingDocProcessing(item)"
            >
              <span class="number-1 font-size__large font-weight__bold">
                {{ item.countOfUnreadBanHanhOutGoingDoc || 0 }} </span
              >&nbsp;
              <span class="font-size__small font-weight__normal color__green"
                >mới</span
              >
            </div>
            <!-- <div class="theTitle txt-center flex-row flex__center">
              <span class="number-1 font-size__large font-weight__bold">0</span>&nbsp;
              <span class="number-2">0 mới</span>
            </div> -->
            <!--<div class="theTitle theTitle__lv4 txt-center flex-row flex__center">-->
            <!--<span class="number-1 font-size__large font-weight__bold">0</span>&nbsp;-->
            <!--<span class="number-2">0 mới</span>-->
            <!--</div>-->
          </div>
        </div>
      </div>
    </template>
  </cardTemplate>
</template>


<script>
// import dashBoardService from "../../services/dashBoardService";
import h from "../../services/h";
import { EventBus } from "../../event-bus";
import constants from "../../constants";

export default {
  name: "summaryCard",
  components: {
    cardTemplate: () => import("../common/cardTemplate.vue"),
  },
  data() {
    return {
      // dashboards: [],
    };
  },
  computed: {
    userDeptRoles() {
      return this.$store.getters.userDeptRoles;
    },
    visibleUserDeptRoles() {
      return this.$store.getters.userDeptRoles.map((item) => {
        if (
          item.roleCode !== constants.ROLE.CODE.PHONG_HOP.QL_PHONG_HOP &&
          item.roleCode !== constants.ROLE.CODE.DIEU_XE.QUAN_LY_XE &&
          item.roleCode !== constants.ROLE.CODE.DANG_KY_LICH_TUAN &&
          item.roleCode !== constants.ROLE.CODE.TONG_HOP_LICH_TUAN
        ) {
          return item.roleId;
        }
      });
    },
    visibleDashboardItems() {
      return this.dashboards.filter(
        (item) =>
          !this.isVisible(item.userDeptRole) &&
          this.visibleUserDeptRoles.includes(item.userDeptRole.roleId) &&
          (!this.dataVanThu ||
            !this.dataVanThu.length ||
            !this.dataVanThu
              .map((vanthu) => vanthu.userDeptRoleView.positionId)
              .includes(item.userDeptRole.positionId))
      );
    },
  },
  created() {
    // this.loadData();
  },

  props: ["dashboards", "dataVanThu"],

  methods: {
    // loadData() {
    //   dashBoardService
    //     .getData()
    //     .then((response) => (this.dashboards = response.data));
    // },

    buildUserDeptRoleLabel(userDeptRole) {
      let userDeptRoleView = h.find(
        this.userDeptRoles,
        (item) => item.id == userDeptRole.id
      );
      return userDeptRoleView
        ? `${userDeptRoleView.positionName} ${userDeptRoleView.deptName}`
        : null;
    },

    viewListIncomingDocProcessing(item) {
      let userDeptRole = item.userDeptRole;
      this.$store.commit("changeUserDeptRole", userDeptRole.id);
      EventBus.$emit(constants.EVENT_BUS.CHANGE_USER_DEPT_ROLE, {
        userDeptRoleId: userDeptRole.id,
      });

      userDeptRole &&
        this.$router.push({
          name: "vbDenChoXuLy",
          params: {
            userDeptRoleId: userDeptRole.id,
            dateRange: constants.DATE_QUICK_FILTER.CODE.NAM_NAY,
          },
        });
    },

    viewListOutgoingDocProcessing(item) {
      let userDeptRole = item.userDeptRole;
      this.$store.commit("changeUserDeptRole", userDeptRole.id);
      EventBus.$emit(constants.EVENT_BUS.CHANGE_USER_DEPT_ROLE, {
        userDeptRoleId: userDeptRole.id,
      });

      userDeptRole &&
        this.$router.push({
          name: "vbDuThaoNew",
          params: { userDeptRoleId: userDeptRole.id },
        });
    },

    viewListBanHanhOutgoingDocProcessing(item) {
      let userDeptRole = item.userDeptRole;
      this.$store.commit("changeUserDeptRole", userDeptRole.id);
      EventBus.$emit(constants.EVENT_BUS.CHANGE_USER_DEPT_ROLE, {
        userDeptRoleId: userDeptRole.id,
      });

      userDeptRole &&
        this.$router.push({
          name: "vbDaPhatHanhNew",
          params: { userDeptRoleId: userDeptRole.id },
        });
    },

    isVisible(item) {
      let userDeptRoleView = h.find(
        this.userDeptRoles,
        (userDeptRole) => userDeptRole.id == item.id
      );
      return (
        // userDeptRoleView.roleCode === "vanthu" ||
        userDeptRoleView.roleCode === "admin"
      );
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/dashboard/SummaryCard.vue